import platform from "platform";
import i18n from "../i18n/i18n";

export const DeviceOs = () => {
    const os = platform.os;
    return os.family ? `${os.family}`.trim().toLowerCase() : i18n.t("unknown");
};